export const Lot2Col = { xxl: 12, xl: 24 };

export const Lot3Col = { xxl: 8, xl: 12, lg: 24 };

export const Lot2To1Col = { xxl: 6, xl: 12, md: 24 };

export const LotMapCol = { xxl: 18, md: 24 };

export const TENDER_TABLE_SCROLL_Y = `calc(100vh - 360px)`;
